(() => {
  function bindSound(root) {
    const button = root.querySelector('[data-cga-sound]');
    const audio = root.querySelector('[data-cga-audio]');
    const label = root.querySelector('[data-cga-sound-label]');
    const note = root.querySelector('[data-cga-sound-note]');
    if (!button || !audio || button.dataset.bound) return;
    button.dataset.bound = 'true';
    const stop = () => {
      audio.pause();
      audio.currentTime = 0;
      button.setAttribute('aria-pressed', 'false');
      label.textContent = 'Play shore sounds';
      note.textContent = 'Real surf and distant shorebirds. Optional. Off by default.';
    };
    button.addEventListener('click', async () => {
      if (button.getAttribute('aria-pressed') === 'true') return stop();
      audio.volume = 0.3;
      try {
        await audio.play();
        button.setAttribute('aria-pressed', 'true');
        label.textContent = 'Stop shore sounds';
        note.textContent = 'Real surf and distant shorebirds. Tap again to stop.';
      } catch {
        note.textContent = 'Audio could not play here. Please try again.';
      }
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden && !audio.paused) stop();
    });
    window.addEventListener('pagehide', stop);
  }
  const init = () => document.querySelectorAll('.cga-ocean-home').forEach(bindSound);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
